import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import {
  TableHeader,
  TableContent,
  usePreventTableScrollingRef,
  TABLE_LAYOUT_OPTIONS,
  TableContainer,
  CELL_RENDERERS,
  Radio} from 'cdk-radial';
import classNames from 'classnames';
import {
    setSelectedLocation
  } from '../../../../../redux/connectedComponent/apiFields/apiFields.slice';

export default function LocationSelector(props) {
  const dispatch = useDispatch();
  const { subscribedLocations, isBulkSubscribed } = props;

  const { allLocations } = useSelector((state) => state?.loginDetailsSlice);

  const {selectedLocation} = useSelector((state) => state?.apiFieldsSlice)

  const [searchText, setSearchText] = useState('');



  const handleLocationSelection = (entityId,location) => {
    dispatch(setSelectedLocation({entityId,location}))
  }

  const handleSearch = (searchInput) => {
    setSearchText(searchInput)
    if (gridRef?.current?.api) {
        gridRef?.current?.api?.setQuickFilter(searchInput);
        gridRef?.current?.api?.refreshCells({
          force: true
        });
      }

  }


  const LocationRenderer = (props) => {
    const {
        data:{
            cmfNumber,
            location,
            entityId
        },
        selectedLocation
    } = props;
    return (
      <Radio
        id={`radio-${entityId}`}
        data-testid={`radio-${entityId}`}
        key={`radio-${entityId}`}
        label={location}
        labelPosition="after"
        onChange={() => handleLocationSelection(entityId,location)}
        size="standard"
        checked={entityId === selectedLocation }
        value={entityId}
      />
    );
  };

  const columns = [
    {
      cellRendererFramework: LocationRenderer,
      field: 'location',
      headerName: 'Dealership Location',
      width: 550,
      lockPosition: true,
      resizable: true,
      cellRendererParams:{
        selectedLocation: selectedLocation
      }
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'address',
      headerName: 'Address',
      width: 680,
      lockPosition: true,
      resizable: true,
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'cmfNumber',
      headerName: 'CMF Number',
      width: 200,
      lockPosition: true,
    },
  ];

  const [data, setData] = useState([]);
  const tableContentRef = usePreventTableScrollingRef();
  const gridRef = useRef();
  const headerProps = {
    headerTitle: <span className='select-location-title-text'>Dealership Locations ({subscribedLocations?.length}) </span>,
    id: `locations-table-header`,
    isSearchable: true,
    isDownloadable: false,
    isPrintable: false,
    isAlwaysExpanded: false,
    onSearchInputChange: handleSearch,
    searchInputValue: searchText,
    searchInputName:"table-search-input-name",
    dataTestId:'locations-table-header'
  };

  function adjustGridHeight(params) {
    var gridContainer = document.getElementById('ag-grid-container');
    var rowCount = params.api.getDisplayedRowCount();
    if (gridContainer) {
      if (rowCount > 7) {
        gridContainer.style.height = '500px';
        gridContainer.style.overflow = 'auto';
      } else {
        gridContainer.style.height = 'auto';
      }
    }
  }

  const handleGridReady = (params) => {
    adjustGridHeight(params);
  };

  useEffect(() => {
    let locations = [];
    subscribedLocations?.length &&
      subscribedLocations?.forEach((subscription) => {
        allLocations?.length &&
          allLocations?.forEach((locationObj) => {
            const isEntityMatch =
              subscription.entityId === locationObj.entityId;
            const isStoreMatch =
              subscription.storeId === locationObj.storeId ||
              subscription.orgUnitId === locationObj.storeId;
            const isLocationUnique = !locations
              .map((loc) => loc.entityId)
              .includes(locationObj.entityId);
            const entityCmfNumberMatch =
              subscription?.entitycmfNumber === locationObj?.cmfNumber;

            const shouldInclude = isBulkSubscribed
              ? isEntityMatch && isLocationUnique
              : isEntityMatch &&
                isStoreMatch &&
                isLocationUnique &&
                entityCmfNumberMatch;

            if (shouldInclude) {
              let address = locationObj.addresses || [];
              let fullAddress =
                address[0] && address[0].streetAddress + ', ' + address[0].city;
              locations.push({
                location: locationObj.partyName,
                address: fullAddress,
                cmfNumber: subscription?.entitycmfNumber || 'N/A',
                entityId:subscription?.entityId,
              });
            }
          });
      });
    setData(locations);
  }, [subscribedLocations, isBulkSubscribed, allLocations]);

  return (
    <TableContainer id='ag-grid-container' className={classNames('edit-fields-locations-table','ag-theme-balham')}>
      <TableHeader {...headerProps} />
      <TableContent data-testid="table-content" className='edit-fields-locations-table-content' ref={tableContentRef}>
        <AgGridReact
          defaultColDef={{cellDataType : false}}
          columnDefs={columns}
          domLayout={TABLE_LAYOUT_OPTIONS.AUTO_HEIGHT}
          onGridReady={handleGridReady}
          rowData={data}
          rowHeight={50}
          style={{ width: '100%' }}
          suppressPaginationPanel
          suppressAutoSize
          ref={gridRef}
        />
      </TableContent>
    </TableContainer>
  );
}
